var Marionette = require('backbone.marionette');

var CommonUtils = require('../../utils/common-utils.js');

var DeterminationOfNeedRevisedView = Marionette.View.extend({
    template: require('../../templates/med-forms/determination-of-need-revised-view.html'),

    ui: {
        comment: '.donr-comment',
        levelOfImpairmentInfo: '#level-of-impairment-info',
        unmetNeedForCareInfo: '#unmet-need-for-care-info'
    },

    events: {
        'change @ui.comment': 'onCommentChanged',
        'click .loi a': 'onLoiRadioButtonsClick',
        'click .unfc a': 'onUnfcRadioButtonsClick'
    },

    templateContext: function () {
        var that = this;
        return {
            rows: that.determinationOfNeedRevised,
            calculateSum: that.calculateSum
        }
    },


    initialize: function (options) {
        this.determinationOfNeedRevised = options.determinationOfNeedRevised;
        this.isEditMode = options.isEditMode;
        this.utils = new CommonUtils();
    },

    onRender: function () {
        var that = this;
        this.ui.levelOfImpairmentInfo.popover({html: true});
        this.ui.unmetNeedForCareInfo.popover({html: true});
    },
    
    onLoiRadioButtonsClick: function (event) {
        this.changeScore(event, "levelOfImpairment");
    },

    onUnfcRadioButtonsClick: function (event) {
        this.changeScore(event, "unmetNeedForCare");
    },

    changeScore: function(event, field) {
        if (!this.isEditMode)
            return;

        var target = $(event.target);
        var value = target.data('title');

        target.parent().find('a').not('[data-title="' + value + '"]').removeClass('active').addClass('notActive');
        target.removeClass('notActive').addClass('active');

        var rowId = $(event.target).closest('tr').attr('id');
        this.determinationOfNeedRevised[rowId][field] = value;
        this.triggerMethod('changed-don-r');
        this.recalculateTotals();
    },

    onCommentChanged: function (event) {
        var rowId = $(event.target).closest('tr').attr('id');
        this.determinationOfNeedRevised[rowId].comment = event.target.value;
        this.triggerMethod('changed-don-r');
    },

    calculateSum: function (column, start, stop, rows) {
        var sum = 0;
        for (var rowId = start; rowId <= stop; rowId++){
            sum += rows[rowId][column];
        }
        return sum;
    },

    recalculateTotals: function () {
        var that = this;
        this.determinationOfNeedRevised.filter(function (row) {
            return !row.editable;
        }).forEach(function (row) {
            row.levelOfImpairment = that.calculateSum('levelOfImpairment', row.start, row.stop, that.determinationOfNeedRevised);
            row.unmetNeedForCare = that.calculateSum('unmetNeedForCare', row.start, row.stop, that.determinationOfNeedRevised);
            var index = that.determinationOfNeedRevised.indexOf(row);
            $('#levelOfImpairment-' + index).html(row.levelOfImpairment);
            $('#unmetNeedForCare-' + index).html(row.unmetNeedForCare);
        } )
    }
});

module.exports = DeterminationOfNeedRevisedView;


//////////////////
// WEBPACK FOOTER
// ./app/views/med-forms/determination-of-need-revised-view.js
// module id = 370
// module chunks = 0